import * as colors from "@mui/material/colors";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const Benefits = ({ themeMode = "light" }) => {
	const theme = useTheme();

	return (
		<Box>
			<Box marginBottom={4}>
				<Typography
					sx={{ textTransform: "uppercase", fontWeight: "medium" }}
					gutterBottom
					color="secondary"
					align="center">
					<svg
						width={40}
						height={40}
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor">
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
						/>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
						/>
					</svg>
				</Typography>
				<Box
					component={Typography}
					sx={{ fontWeight: 700 }}
					variant="h3"
					gutterBottom
					align="center">
					What hundreds of franchise brands
					<br />
					love about Mango
				</Box>
				<Typography
					align="center"
					color="textSecondary"
					variant="h6"
				/>
			</Box>
			<Grid
				container
				spacing={2}>
				{[
					{
						title: "Attract Quality Prospects",
						subtitle:
							"Give an engaging, professional presentation of a territory and its demographics to prospective franchisees.",
						icon: (
							<svg
								width={24}
								height={24}
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor">
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z"
								/>
							</svg>
						),
						color: colors.deepOrange,
					},
					{
						title: "Offer Investors Confidence",
						subtitle:
							"Franchisors can invest knowing they will have a viable business with enough customers in their territory.",
						icon: (
							<svg
								width={24}
								height={24}
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor">
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
								/>
							</svg>
						),
						color: colors.deepOrange,
					},
					{
						title: "Shorten Sales Cycles",
						subtitle:
							"Empowered by data in one engaging platform, prospects make quicker decisions leading to significantly shorter sales cycles.",
						icon: (
							<svg
								width={24}
								height={24}
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor">
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
								/>
							</svg>
						),
						color: colors.deepOrange,
					},
				].map((item, i) => (
					<Grid
						item
						xs={12}
						md={4}
						key={i}>
						<Box
							width={1}
							height="100%"
							data-aos="fade-up">
							<Box
								display="flex"
								flexDirection="column"
								alignItems="center">
								<Box
									bgcolor={theme.palette.alternate.dark}
									variant="rounded"
									width={60}
									height={60}
									component={Avatar}
									color={item.color[themeMode === "light" ? 500 : 700]}>
									{item.icon}
								</Box>
								<Typography
									variant="h6"
									gutterBottom
									sx={{ fontWeight: 500 }}
									align="center">
									{item.title}
								</Typography>
								<Typography
									align="center"
									color="textSecondary">
									{item.subtitle}
								</Typography>
							</Box>
						</Box>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default Benefits;
